export function registerPwaServiceWorker(): void {
  if (!('serviceWorker' in navigator) || !window.isSecureContext) return;

  let registration: ServiceWorkerRegistration | undefined;
  let reloading = false;
  const reloadOnControllerChange = () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener('controllerchange', reloadOnControllerChange);

  void navigator.serviceWorker.register('/service-worker.js', { updateViaCache: 'none' })
    .then((nextRegistration) => {
      registration = nextRegistration;
      return registration.update();
    })
    .catch(() => {
      // PWA support is optional; the live dashboard must work without a service worker.
    });

  const update = () => { void registration?.update().catch(() => undefined); };
  window.addEventListener('focus', update);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') update();
  });
  window.setInterval(update, 60 * 60 * 1000);
}
